<h1>Expression Tester</h1>>
<h2>Expression</h2>
<textarea rows="10" cols="40" [(ngModel)]="ruleText"></textarea>

<h2>Context</h2>
<textarea rows="10" cols="40" [(ngModel)]="contextJson"></textarea>
<button class="button" (click)="doTest()">Test</button>

<h2>Result</h2>
<textarea rows="10" cols="40" [(ngModel)]="result"></textarea>